module.exports = "./assets/fonts/La-Belle-Aurore.woff";